import { render, staticRenderFns } from "./kbankLive.vue?vue&type=template&id=5e69e4d8&scoped=true&"
import script from "./kbankLive.vue?vue&type=script&lang=js&"
export * from "./kbankLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e69e4d8",
  null
  
)

export default component.exports